import { format, subDays, subMonths, subYears } from "date-fns";

import { DashboardPeriodOptions } from "./enums";

interface GetDateIntervalByPeriodProps {
  selectedPeriod: DashboardPeriodOptions;
}

export const getDateIntervalByPeriod = ({ selectedPeriod }: GetDateIntervalByPeriodProps) => {
  const now = new Date();
  let fromDate: Date | undefined;
  let toDate: Date | undefined;

  switch (selectedPeriod) {
    case DashboardPeriodOptions.TODAY:
      fromDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0);
      break;
    case DashboardPeriodOptions.LAST_15_DAYS:
      fromDate = subDays(now, 15);
      toDate = now;
      break;
    case DashboardPeriodOptions.LAST_MONTH:
      fromDate = subMonths(now, 1);
      toDate = now;
      break;
    case DashboardPeriodOptions.MONTH_TO_DATE:
      fromDate = new Date(now.getFullYear(), now.getMonth(), 1);
      toDate = now;
      break;
    case DashboardPeriodOptions.LAST_YEAR:
      fromDate = new Date(subYears(now, 1));
      toDate = now;
      break;
    default:
      break;
  }

  const from = fromDate ? format(fromDate, "dd/MM/yyyy") : undefined;
  const to = toDate ? format(toDate, "dd/MM/yyyy") : undefined;

  if (from?.length && to?.length) {
    return `${from} - ${to}`;
  }
  if (from?.length) {
    return from;
  }
};
